import React from 'react';

interface IVisaIconProps {
	className?: string;
}

export const VisaIcon = ({ className }: IVisaIconProps) => (
	<svg
		aria-hidden="true"
		width="44"
		height="32"
		viewBox="0 0 44 32"
		fill="none"
		className={`align-middle ${className}`}>
		<rect x="0.5" y="0.5" width="43" height="31" rx="3.5" stroke="#EBEBEB" />
		<path d="M19.8302 20.8557H17.1938L18.8428 11.1754H21.4791L19.8302 20.8557Z" fill="#15195A" />
		<path
			d="M29.3875 11.4121C28.8675 11.2163 28.0427 11 27.0228 11C24.4193 11 22.5859 12.3181 22.5747 14.2026C22.5531 15.5929 23.8873 16.3652 24.8853 16.8288C25.9053 17.3025 26.252 17.6117 26.252 18.0339C26.2416 18.6825 25.4278 18.9814 24.6687 18.9814C23.6162 18.9814 23.0522 18.8273 22.1951 18.4665L21.8479 18.3118L21.479 20.4848C22.0973 20.7523 23.2366 20.9896 24.4193 21C27.1856 21 28.9866 19.7023 29.0079 17.6941C29.0184 16.5921 28.3139 15.7477 26.7949 15.0578C25.8728 14.6148 25.3081 14.3162 25.3081 13.863C25.3189 13.451 25.7857 13.029 26.8266 13.029C27.6837 13.0083 28.3134 13.2039 28.7905 13.3997L29.0289 13.5025L29.3875 11.4121Z"
			fill="#15195A"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M34.107 11.1754H36.1462L38.2731 20.8555H35.8321C35.8321 20.8555 35.5932 19.7433 35.5175 19.4034H32.1326C32.0347 19.6608 31.5793 20.8555 31.5793 20.8555H28.813L32.729 11.9786C33.0003 11.3503 33.4781 11.1754 34.107 11.1754ZM33.9437 14.7178C33.9437 14.7178 33.1082 16.8702 32.8911 17.4263H35.0825C34.9741 16.9423 34.4748 14.6252 34.4748 14.6252L34.2906 13.7911C34.213 14.0059 34.1008 14.3012 34.0251 14.5003C33.9738 14.6354 33.9393 14.7262 33.9437 14.7178Z"
			fill="#15195A"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.77045 11.1755H10.0122C10.5871 11.1959 11.0536 11.3709 11.2054 11.9892L12.1265 16.4332C12.127 16.4347 12.1274 16.4362 12.1279 16.4377L12.41 17.7765L14.992 11.1755H17.7797L13.6358 20.8455H10.8478L8.49809 12.4344C7.68723 11.9843 6.76178 11.6223 5.72705 11.3711L5.77045 11.1755Z"
			fill="#15195A"
		/>
	</svg>
);
